import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import BloodGroupForm from '../components/forms/BloodGroupForm';
import '../styles/EmployeeMaster.css';
import BloodGroupTable from '../components/BloodGroupTable';

const BloodGroupModel = () => {
     const navigate = useNavigate();
     const location = useLocation();

     const showModal = location.pathname === '/bloodgroup/add';

     const handleAddClick = () => {
          navigate('/bloodgroup/add');
     };

     const handleCloseModal = () => {
          navigate('/bloodgroup');
     };

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Blood Group Master</h2>
                    <button className="add-employee-btn" onClick={handleAddClick}>
                         Add Blood Group
                    </button>
               </div>

               <BloodGroupTable />

               <Modal
                    show={showModal}
                    onHide={handleCloseModal}
                    size="md"
                    centered
               >
                    <Modal.Header closeButton>
                         <Modal.Title>Add New Blood Group</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <BloodGroupForm />
                    </Modal.Body>

               </Modal>
          </div>
     );
};

export default BloodGroupModel;